export default __webpack_public_path__ + "static/media/Link1.e5a4e0c4.svg";